import { Component, OnInit } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-mostrar-produto-categoria',
  templateUrl: './mostrar-produto-categoria.component.html',
  styleUrls: ['./mostrar-produto-categoria.component.css']
})
export class MostrarProdutoCategoriaComponent implements OnInit {
  produtos = [];
  constructor(private dados:DadosService, private params:ActivatedRoute) { 

     console.log(this.params.snapshot.params);


  }

  ngOnInit() {
    if (this.params.snapshot.params.codigo){
      this.getProdutosCateg(this.params.snapshot.params.codigo);
    }
  }

  getProdutosCateg( categoria:number )
  { 
    if (categoria==null){
      this.dados.grupoCorrente = Number(this.params.snapshot.params.codigo);
      categoria = Number(this.dados.grupoCorrente);
    } else
    {
      this.dados.grupoCorrente = categoria;
    }
    return this.dados.getProdutosCateg(categoria,d=>{
      console.log("produtos",d);
      this.produtos = d;
    });
  }

}
